import styled from 'styled-components';

export const HeaderContainer = styled.div`
  background-color: black;
  width: auto;
  text-align: center;
`;
